import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

const CommercialFields = ({
  form,
  inlineErrors,
  identityValidation,
  onChange,
  showInlineError,
}) => {
  const shouldLockTaxpayerBusinessName =
    identityValidation.status === "validated" && identityValidation.taxpayerFound;

  return (
    <Row form>
      <Col md={4}>
        <FormGroup>
          <Label>
            Razón Social <span className="required-mark">*</span>
          </Label>
          <Input
            name="business_name"
            autoComplete="organization"
            invalid={Boolean(inlineErrors.businessName)}
            value={form.businessName}
            disabled={form.personType === "FISICA" && shouldLockTaxpayerBusinessName}
            readOnly={form.personType === "MORAL" && shouldLockTaxpayerBusinessName}
            onChange={(event) => onChange("businessName", event.target.value)}
            placeholder="campo obligatorio"
          />
          {showInlineError("businessName")}
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label>Nombre Comercial</Label>
          <Input
            name="commercial_name"
            autoComplete="organization-title"
            invalid={Boolean(inlineErrors.commercialName)}
            value={form.commercialName}
            onChange={(event) => onChange("commercialName", event.target.value)}
            placeholder="campo opcional"
          />
          {showInlineError("commercialName")}
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label>
            Sucursal Principal <span className="required-mark">*</span>
          </Label>
          <Input
            name="branch_name"
            autoComplete="off"
            invalid={Boolean(inlineErrors.branchName)}
            value={form.branchName}
            onChange={(event) => onChange("branchName", event.target.value)}
            placeholder="campo obligatorio"
          />
          {showInlineError("branchName")}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default CommercialFields;
